<template>
    <list-view class="service-schema-data-list-view">
        <template slot="filterContent">
            <veui-fieldset>
                <veui-field>
                    <veui-select :options="store.schemaServiceListDatasource"
                        @change="selectService"
                        v-model="store.serviceId"/>
                </veui-field>
            </veui-fieldset>
            <veui-span class="schema-data-title">表单数据报告</veui-span>
        </template>
        <template slot="tableColumns">
            <template v-for="column in columns">
                <veui-table-column :key="column" :field="column" :title="column">
                    <template slot-scope="props">
                        <p class="table-multi-line">{{props[column]}}</p>
                    </template>
                </veui-table-column>
            </template>
        </template>
    </list-view>
</template>

<script>
import ListView from '@baidu/ve-ria/views/ListView';
import ListModel from './ListModel';
import createView from '@baidu/ve-ria/views/createView';
import {
    Field,
    Fieldset,
    Span,
    Button,
    Select,
    Column
} from 'veui';
import {get} from 'lodash';
import autoSubmit from '@baidu/ve-ria/directives/autoSubmit';

export default createView(ListView, ListModel, {
    name: 'SchemaStoreListView',
    components: {
        'veui-fieldset': Fieldset,
        'veui-field': Field,
        'veui-table-column': Column,
        'veui-select': Select,
        'veui-button': Button,
        'veui-span': Span
    },
    directives: {
        autosubmit: autoSubmit
    },
    computed: {
        columns() {
            return Object.keys(get(this.store.tableData, '0', {}));
        }
    },
    created() {
        this.store.requestServiceList();
    },
    methods: {
        selectService(val) {
            // list接口已经调用了？
            this.global.router.push({params: {serviceId: val}});
        }
    }
});
</script>

<style lang="less">
.service-schema-data-list-view {
    .schema-data-title {
        display: inline-block;
        line-height: 36px;
    }
}

</style>
